import { settingsActionsTypes } from "../constants/ActionTypes";
import {apiGet, apiPost} from "../utils/Api";
import { NotificationManager } from 'react-notifications';

const setAvailableLocalesAction = (data) => {
  return {
    type: settingsActionsTypes.SET_AVAILABLE_LOCALES,
    locales: data.locales,
    defaultLocale: data.defaultLocale
  };
};

const setLocaleAction = (locale) => {
  return {
    type: settingsActionsTypes.SET_LOCALE,
    locale: locale
  };
};

export const getLocales = () => (dispatch, getState) => {

  return apiGet('/settings/i18n', null, { defaultErrorHandler: false })
    .then((json) => {
      // jeśli 401 zostało zwrócone „miękko” przez backend jako status:error,
      // json może być wyjątkiem, ale jeśli cokolwiek przyszło i nie ma danych — po prostu pomiń
      if (!json || json.statusCode === 401) return;
      dispatch(setAvailableLocalesAction(json.data));
    })
    .catch((err) => {
      if (err && err.statusCode === 401) {

        return;
      }
    });
};

const setLocale = (locale) => {
  return (dispatch) => {
    apiPost(`/settings/i18n/${locale}`)
      .then(json => {
        if (json.status === 'success') {
          localStorage.setItem("userLocale", locale);
          window.location.reload();
        }
      });
  };
};

const getSettings = () => {
  return (dispatch) => {
    // apiGet("/settings")
    //       .then((json) => {
    //        // console.log('json', json);
    //         // dispatch(setAvailableLocalesAction(json.data));
    //       });
  };
};

export default {
  getLocales,
  setLocale,
  getSettings
};



// WEBPACK FOOTER //
// ./actions/settings.actions.js